<script>
import ProductPriceMixin from './mixins/product-price';
import ProductVariantAttributesMixin from './mixins/product-variant-attributes';

import CartForm from '../cart/CartForm.vue';
import SupplierLogo from './SupplierLogo.vue';

export default {
  name: 'ProductDetailVariant',
  components: { CartForm, SupplierLogo },
  mixins: [ProductPriceMixin, ProductVariantAttributesMixin],
  props: ['variant'],
};
</script>

<template>
  <tr class="flex flex-col md:table-row mb-4">
    <td class="border pl-1 md:pl-2 md:h-10 h-8 flex items-center md:table-cell">
      {{ getOptionValue('Conditionnement') }}
    </td>
    <td class="border pl-1 md:pl-2 md:h-10 h-8 flex items-center md:table-cell">
      {{ variant.sku }}
    </td>
    <td class="border pl-1 md:pl-2 md:h-10 h-8 flex items-center md:table-cell">
      <SupplierLogo :supplier="getOptionValue('Supplier')" />
    </td>
    <td class="border pl-1 md:pl-2 md:h-10 h-8 flex items-center md:table-cell">
      {{ getOptionValue('Certification') }}
    </td>
    <td class="border pl-1 md:pl-2 md:h-10 h-8 flex items-center md:table-cell">
      {{ getOptionValue('Dilution') }}
    </td>
    <td class="border md:h-10 h-8 md:table-cell">
      <div v-if="variant.file_tds" class="flex items-center justify-center w-full">
        <a target="_blank" :href="variant.file_tds"
           class="text-blue-diagomics-dark text-xs inline-flex items-center justify-center">
          <img :src="require('images/adobe-pdf-icon.png')" class="h-8"/>
        </a>
      </div>
      <button v-else
        onclick="location.href='mailto:info@diagomics.com';"
        class="bg-gray-50 rounded-md p-2 inline-flex items-center justify-center text-sm
        text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none
        focus:text-gray-500 h-8
        w-full"
      >
        <div class="scale-75">
         Sur demande
       </div>
     </button>
    </td>
    <td class="border pl-1 md:h-10 h-12 flex items-center md:table-cell">
      <CartForm :variant="variant" />
    </td>
  </tr>
</template>
